/**
 * Element Plus 插件配置
 * @description Element Plus 组件库的全局配置
 */
import type { App } from 'vue'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'

// Element Plus 全局配置
export function setupElementPlus(app: App) {
  // 安装 Element Plus
  app.use(ElementPlus)

  // 注册所有图标
  for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
  }
}

export default setupElementPlus
